import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    notReadyTitle: 'Курс не готов к публикации',
    notReadyBody: 'Исправьте, пожалуйста, следующие проблемы:',
    close: 'Закрыть',
    soon: 'скоро',
  },
  en: {
    notReadyTitle: 'The course isn’t ready to publish',
    notReadyBody: 'Fix the following issues:',
    close: 'Close',
    soon: 'Soon',
  },
})
